module.exports = __webpack_public_path__ + "static/media/vulve-verte.f6232916.png";